// extracted by mini-css-extract-plugin
export default {"buttonLink":"ButtonLink_buttonLink__2CoO8","disabled":"ButtonLink_disabled__IDE8p"};